<template>
  <div>
    <div class="step-progress-indicator">
      <div class="step-progress-indicator-inner">
        <div class="line"></div>
        <div class="step-container" v-for="index in numberOfSteps" :style="`${stepStyle(index)}`" :key="index">
          <div class="step" :class="{ complete: index < currentStep, active: index === currentStep }">
            <span v-if="index < currentStep" class="primary-fill-svg">
              <inline-svg :src="require('@/assets/fa/check-blue.svg')" alt="" />
            </span>
            <div v-else>{{ index }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepProgressIndicator',
  props: {
    numberOfSteps: {
      type: Number,
      required: true,
    },
    currentStep: {
      type: Number,
      required: true,
    },
  },
  methods: {
    stepStyle(index) {
      if (index === 1) {
        return 'left: -22px;';
      }
      if (index === this.numberOfSteps) {
        return 'width: 100%; float: right; right: -22px;';
      }
      return `width: ${Math.floor(((index - 1) / (this.numberOfSteps - 1)) * 100)}%; margin-left: 22px;`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/variables';
$step-inactive-color: #6d7783;
$step-active-color: $primary-dark;

.step-progress-indicator {
  position: relative;
  height: 44px;
  width: 100%;
  padding: 0 22px;
  .step-progress-indicator-inner {
    position: relative;
    width: 100%;
    .step-container {
      float: left;
      height: 44px;
      position: absolute;
      .step {
        height: 44px;
        width: 44px;
        float: right;
        position: relative;
        border-radius: 50%;
        line-height: 43px;
        color: $step-inactive-color;
        border: 1px solid $step-inactive-color;
        background-color: #fff;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06);
        font-size: 18px;
        font-weight: bold;
        text-align: center;
        &.active,
        &.complete {
          color: $step-active-color;
          border: 1px solid $step-active-color;
          background-color: $primary-light-background;
        }
        &.complete {
          line-height: 40px;
        }
      }
    }
  }
  .line {
    position: absolute;
    width: 100%;
    top: 22px;
    height: 1px;
    background-color: rgb(218, 226, 234);
  }
}
</style>
